<script>
import { storeToRefs } from 'pinia';
import { useReservationStore } from '../../../store/contact/ReservationStore';

export default {
    setup() {
        const store = useReservationStore();
        const { totalSteps, currentStep } = storeToRefs(store);
        return {
            totalSteps,
            currentStep,
        };
    },
};
</script>
<template>
    <div
        class="steps-list"
        style="--active-color: #7c826b; --passive-color: #cfd0d0"
    >
        <ul>
            <li
                :class="currentStep === step ? 'step-active' : ''"
                v-for="step in totalSteps"
            >
                <div class="step-count">{{ step }}</div>
            </li>
        </ul>
    </div>
</template>
